<template>
  <div class="subscription">
    <div class="instance">
      <div class="row first">
        <div class="col-xl-3 col-l-4 col-m-7 col-s-6 col-xs-8">
          <h4><slot name="name"/></h4>

          <dl class="sr">
            <dt class="col-xl-sr-only col-l-sr-only">
              <!-- #S573 -->
              {{ $t('order.type_label') }}
            </dt>
            <dd class="col-xl-sr-only col-l-sr-only">
              <slot name="type" />
            </dd>

            <dt class="col-xl-sr-only"><!-- #S574. keep this in one line, because there are no spacings allowed! -->{{ $t('order.externalid_label') }}</dt>
            <dd class="col-xl-sr-only">
              <slot name="creationDate" />
            </dd>

            <dt class="col-xl-sr-only col-l-sr-only col-m-sr-only">
              <!-- #S575 -->
              {{ $t('order.dueDate_label') }}
            </dt>
            <dd class="col-xl-sr-only col-l-sr-only col-m-sr-only">
              <slot name="dueDate" />
            </dd>

            <dt class="col-xl-sr-only col-l-sr-only col-m-sr-only col-s-sr-only">
              <!-- #S576 -->
              {{ $t('order.status_label') }}
            </dt>
            <dd class="col-xl-sr-only col-l-sr-only col-m-sr-only col-s-sr-only">
              <slot name="state" />
            </dd>
          </dl>
        </div>
        <div class="col-l-2 col-m-hide col-s-hide col-xs-hide" aria-hidden="true">
          <slot name="type" />
        </div>
        <div class="col-xl-2 col-l-hide col-m-hide col-s-hide col-xs-hide" aria-hidden="true">
          <slot name="creationDate" />
        </div>
        <div class="col-xl-2 col-l-3 col-m-hide col-s-hide col-xs-hide" aria-hidden="true">
          <slot name="dueDate" />
        </div>
        <div class="col-l-2 col-m-3 col-s-3 col-xs-hide" aria-hidden="true">
          <slot name="state" />
        </div>
        <div class="col-l-1 col-m-2 col-s-3 col-xs-4 text-right">
          <a href="#" class="text-nowrap" :aria-expanded="isExpanded(item[idKey]) ? 'true' : 'false'" @click.prevent="onToggle(item[idKey])">
            <FontAwesomeIcon :icon="isExpanded(item[idKey]) ? faCaretUp : faCaretDown" />
            {{ $t('common.product_details_toggle_label') }}
          </a>
        </div>
      </div>

      <div class="clearfix">
        <transition name="slide-fade2" appear>
          <keep-alive>
            <VKeepableSlot v-if="isExpanded(item[idKey])" :key="'details' + item[idKey]">
              <div class="offset-top-1" data-test="details">
                <slot name="details" v-bind="item" />
              </div>
            </VKeepableSlot>
          </keep-alive>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCaretUp } from '@fortawesome/free-solid-svg-icons/faCaretUp';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons/faCaretDown';
import VKeepableSlot from '@/components/KeepableSlot';

export default {
  name: 'OrderOverviewGridItemLayout',

  components: {
    FontAwesomeIcon,
    VKeepableSlot,
  },

  props: {
    item: {
      type: Object,
      required: true,
    },

    idKey: {
      type: String,
      required: false,
      default: 'id',
    },

    initialDetailsExpanded: {
      type: Object,
      required: false,
      default() {
        return {};
      },
    },
  },

  data() {
    return {
      detailsExpanded: this.initialDetailsExpanded,
      faCaretUp,
      faCaretDown,
    };
  },

  methods: {
    isExpanded(id) {
      return this.detailsExpanded[id];
    },

    onToggle(id) {
      this.$set(this.detailsExpanded, id, !this.detailsExpanded[id]);
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@scss';

.subscription {
  padding-top: 12px;
  padding-bottom: 12px;
  margin-right: -12px;
  margin-bottom: 24px;
  margin-left: -12px;
  background-color: #fff;
  border: 1px solid #eee;

  h4,
  h5 {
    padding: 0 0 6px;
    margin: 0;
  }

  > .row,
  .instance .row.first {
    padding: 12px 0 0;
    margin: 0 12px;
  }
}
</style>
